export default {
  auth: {
    login: {
      email: {
        title: 'Digite seu e-mail',
        input: {
          label: 'Digite seu e-mail',
          description:
            'Use o endereço de e-mail associado à sua conta {provider} para que possamos verificar os dados da sua associação.',
          placeholder: 'youremail@gmail.com',
        },
      },
      passwordText:
        'Para continuar, enviaremos um código de verificação para o seu e-mail.',
      btnLogin: 'Continuar',
      error: {
        loginFailed: 'Falha no login. Por favor, tente novamente.',
        emailFormat: 'Formato de e-mail incorreto, tente novamente',
        emailError:
          'Insira o e-mail correto ou entre em contato com o suporte, pois esta conta já está vinculada a {email}.',
        emailGenericError:
          'Insira o e-mail correto ou entre em contato com o suporte, pois esta conta já está vinculada a outra conta.',
      },
    },
    checkCode: {
      title: 'Verifique seu e-mail',
      description: 'Enviamos um código de verificação para ',
      wrongEmailTitle: 'E-mail incorreto?',
      reEnterEmailLabel: 'Digite novamente seu e-mail',
      passcodeSubtitle: 'Código de verificação',
      uniqueCodeText:
        'Você poderá solicitar um novo código de verificação em {count} segundos',
      btn: {
        resend: 'Reenviar',
        verify: 'Verificar',
      },
      error: {
        wrongCode:
          'A senha pode estar incorreta ou ter expirado. Por favor, tente novamente.',
        notVerified: {
          title: 'Desculpe, a senha não foi verificada',
          description:
            'Foram feitas muitas tentativas incorretas de inserir a senha de verificação.',
          button: 'Digitar e-mail novamente',
        },
        expired: {
          title: 'O código de verificação expirou',
          description:
            'Infelizmente o código de verificação expirou, então você terá que reiniciar sua reserva novamente',
          button: 'Reiniciar reserva',
        },
      },
    },
    signUp: {
      title: 'Atualizar dados',
      subtitle: 'Atualize seus dados abaixo',
      firstNameInput: {
        label: 'Nome(s)',
        placeholder: 'John',
      },
      lastNameInput: {
        label: 'Sobrenome(s)',
        placeholder: 'Smith',
      },
      emailInput: {
        label: 'E-mail',
      },
      marketingAgreementText:
        'Aceito receber e-mails de marketing personalizados.',
      signUpButton: 'Fazer login',
      validationError: {
        invalidEmail: 'Digite um endereço de e-mail válido.',
        maxLength: 'No máximo 255 caracteres',
        emptyName: 'O nome não pode ficar vazio',
      },
      error: {
        signUpError: 'Ocorreu um erro',
        attempts: {
          title: 'Muitas tentativas incorretas',
          description:
            '5 tentativas incorretas foram feitas para digitar o código de verificação. Tente novamente em uma hora',
          btn: {
            reEnter: 'Digite novamente o e-mail',
            contact: 'Entre em contato com o suporte',
          },
        },
      },
    },
    maintenance: {
      title: 'Manutenção em andamento',
      description:
        'O serviço de reservas está indisponível temporariamente porque uma atualização do sistema está sendo executada. Volte mais tarde ou entre em contato com o suporte.',
      note: 'Volte mais tarde ou',
      btn: {
        support: 'Entre em contato com o suporte',
      },
    },
    notFound: {
      title: 'Página não encontrada',
      description:
        'A página que você procura pode ter sido removida ou está temporariamente indisponível.',
      descriptionMobile: 'Tente novamente ou pesquise outras opções.',
      btn: {
        returnToLounge: 'RETORNAR À SALA VIP',
        support: 'Entre em contato com o suporte',
      },
    },
  },
  lounge: {
    perPerson: 'por pessoa',
    perAdult: 'por adulto',
    errors: {
      server: {
        title: 'O serviço está indisponível temporariamente',
        description:
          'Pode ter ocorrido um erro no sistema. Tente novamente ou pesquise outras opções.',
        btn: {
          return: 'Voltar para Salas',
        },
      },
      createBooking: {
        title: 'Desculpe, não foi possível criar uma reserva.',
        description:
          'Pode haver um erro no sistema. Tente novamente ou explore outras opções.',
      },
      capacity: {
        title: 'Desculpe, as pré-reservas para este lounge estão esgotadas.',
        description: {
          known:
            'Você ainda pode entrar no dia. Nossos parceiros de lounge reservam espaço para visitantes sem reserva, mas talvez seja necessário entrar em uma lista de espera ou fila virtual se estiver cheio.',
          notKnown:
            'Pedimos desculpas, mas a capacidade da sala VIP para o horário que você selecionou é de 2 adultos e 1 criança.',
        },
        solutions: {
          title: 'Você pode',
          points: [
            'Alterar o número de convidados',
            'Alterar os horários',
            'Encontrar outra sala VIP',
          ],
        },
        btn: {
          change: 'Alterar o número de convidados',
          return: 'Retornar às salas VIP',
        },
      },
      loungeClosed: {
        title: 'A sala VIP está fechado',
        description:
          'A pré-reserva não está disponível, pois este lounge não estará operacional no horário previsto para o seu voo.',
        btn: {
          return: 'Retornar às salas VIP',
        },
      },
      maxPeriod: {
        title: 'O período de reservas ainda não está aberto',
        description:
          'As reservas para esta sala VIP só podem ser feitas até {days} dias antes da viagem. Volte a consultar mais perto da data da sua partida.',
        descriptionFastTrack:
          'As reservas para este Airport fast track só podem ser feitas até {days} dias antes da viagem. Volte a consultar mais perto da data da sua partida.',
        descriptionRest:
          'As reservas para este espaço de descanso só podem ser feitas até {days} dias antes da viagem. Volte a consultar mais perto da data da sua partida.',
        btn: {
          return: 'Retornar às salas VIP',
        },
      },
      minPeriod: {
        title: 'Reserva antecipada obrigatória',
        description:
          'As reservas online para esta sala VIP devem ser feitas com pelo menos {hours} horas de antecedência em relação à partida do voo. Você ainda pode visitar a sala diretamente na chegada, sujeito à disponibilidade para clientes sem reserva.',
        btn: {
          return: 'Retornar às salas VIP',
        },
      },
      unavailable: {
        title: 'A sala VIP está indisponível',
        description:
          'Não foi possível atender à sua solicitação para reservar a sala VIP no momento. Pedimos desculpas pela inconveniência causada. Tente novamente mais tarde ou entre em contato com o suporte ao cliente para obter ajuda. Agradecemos a sua compreensão.',
      },
      terminalsMismatch: {
        title: 'Terminais incompatíveis',
        description:
          'Observe que a sala VIP que você está reservando não fica no terminal em que seu voo está programado. O terminal da sala VIP é o Terminal Norte. O terminal de partida do voo é o Terminal Sul. Você ainda quer reservar esta sala VIP, mesmo ela não estando no terminal de partida?',
        btn: {
          return: 'Retornar às salas VIP',
          continue: 'Continuar com a reserva',
        },
      },
      noFlightInfoFound: {
        title: 'Não foi possível localizar seu voo',
        description:
          'Insira os dados do voo manualmente. Saiba que não é possível validar se aeroporto e terminal coincidem.',
        btn: {
          return: 'Voltar às Salas',
          continue: 'Inserir hora do voo',
        },
      },
    },
    topBarLinks: {
      backToLounge: 'VOLTAR PARA ',
      faqs: 'Perguntas frequentes',
      back: 'VOLTAR',
    },
  },
  booking: {
    flightAndGuests: {
      title: 'Voo e entrada de convidados',
      amendTitle: 'Alterações na reserva',
    },
    flightDetails: {
      title: 'Dados do meu voo',
      warning: 'O passe pode ser usado 3 horas antes do voo',
      localeValue: 'pt',
      dateInput: {
        label: 'Data',
        placeholder: 'Data do voo',
      },
      flightTimeInput: {
        label: 'Hora do voo',
      },
      numberInput: {
        label: 'Número do voo',
        placeholder: 'Por exemplo: EZY123',
      },
      time: {
        label: 'Horário do voo',
      },
      errors: {
        invalid_date: 'É preciso informar a data do voo.',
        invalid_dateflight:
          'Informações do voo não reconhecidas. Verifique e tente novamente.',
        invalid_flight:
          'Número do voo não reconhecido. Verifique os dados e tente novamente.',
      },
    },
    guestDetails: {
      title: 'Quem vem?',
      shortDescription: 'O tamanho máximo do grupo é {guests}.',
      unlimitedDescription:
        'O tamanho do grupo está sujeito aos limites de capacidade do lounge.',
      description:
        'O grupo pode ter até {guests}, sem contar {excluded}. Consulte as regras da sala VIP para verificar a quantidade permitida de {excluded}.',
      conjunction: 'e',
      chargeableGuestInfo: '{guests} não pagam pela reserva',
      adults: {
        label: 'Adultos',
        description: 'Faixa etária {age}',
      },
      children: {
        label: 'Crianças',
        description: 'Faixa etária {age}',
      },
      infants: {
        label: 'Bebês',
        description: 'Faixa etária {age}',
      },
      seniors: {
        label: 'Idosos',
        description: 'Faixa etária {age}',
      },
      loungeTerms: {
        line1: 'Consulte as ',
        link: 'regras da sala VIP',
        line2: 'sobre restrições de idade',
      },
      errors: {
        capacity:
          'A capacidade máxima da sala VIP é um total de {guests} convidados. Alterar o número de convidados.',
      },
    },
    availableSlots: {
      title: 'Horário de chegada',
      description:
        'Os horários exibidos seguem o fuso horário local da sala VIP',
      placeholder: 'Selecionar horário',
      arrivalDescription: 'Esse é o horário em que você chegará à sala VIP.',
      stayTime: {
        line1: 'Visto que seu voo é às ',
        line2: ', sua permanência máxima é ',
        line3: '{accessPeriod} horas antes',
      },
      totalPrice: {
        breakdown: {
          adult: 'Adulto',
          child: 'Criança',
          infant: 'Bebê',
        },
        title: 'Preço total',
        titleAmend: 'Preço adicional a pagar',
        titleRefund: 'Valor a receber',
        samePrice: 'Nenhuma taxa adicional é necessária',
      },
      panelInfoHeader: {
        date: 'Data',
        flightTime: 'Horário do voo',
        flightNumber: 'Número do voo',
      },
      busynessIndicator: {
        title: 'Estará movimentada?',
        lowestLabel: 'Improvável',
        highestLabel: 'Muito provável',
        defaultTooltipMessage:
          'O horário de pico pode afetar a capacidade. Selecione o horário de chegada para obter informações sobre a capacidade da sala VIP',
        tooltipMessage: [
          'Geralmente, a sala VIP não fica perto da capacidade total',
          'Esta sala VIP geralmente tem ocupação baixa.',
          'Esta sala VIP pode ficar moderadamente movimentada',
          'Esta sala VIP pode ficar perto da capacidade total. Faça a reserva antecipada da sua visita para garantir seu lugar.',
          'Esta sala VIP pode estar na capacidade total. Faça a reserva antecipada da sua visita para garantir seu lugar',
        ],
        errorTooltipMessage:
          'A disponibilidade da sala VIP não pode ser verificada no momento',
        messageOnError:
          ' A disponibilidade da sala VIP não pode ser verificada no momento. Recomendamos reservar com antecedência para garantir seu acesso.',
        messageBeforeSelected:
          'Escolha o horário de chegada para consultar a disponibilidade da sala VIP',
      },
      hsbcCancelationPolicy: {
        title:
          'Observe que uma taxa de reserva antecipada aplica-se para titulares do cartão HSBC',
        descriptionLine1:
          'Para titulares do cartão HSBC Premier, essa taxa de reserva antecipada será adicionada às taxas de passes de visita suas e de seu(s) convidado(s). Ao chegar à sala VIP, você ainda terá que pagar £ 24 por visitante.',
        descriptionLine2:
          'Para titulares do cartão HSBC Premier World Elite, observe que ainda que você receba passes para visitas grátis para você e titulares do cartão adicionais (ou seja, não seus convidados) a taxa de reserva antecipada será uma taxa separada e também se aplica a você e aos seus convidados. Quando',
      },
      cancellationPolicy: {
        title: 'Política de cancelamento',
        descriptionLine1:
          'Cancelamentos são permitidos até {time} horas antes da reserva — com reembolso integral. Não será possível cancelar ou modificar reservas feitas dentro das {time} horas que antecedem à chegada.',
        descriptionLine2:
          'Confirme se os dados estão corretos antes de fazer o pagamento.',
      },
      btn: 'CONFIRMAR',
      amendBtn: 'PROSSEGUIR COM ALTERAÇÕES',
      errors: {
        airportMismatch: {
          title: 'Os aeroportos não correspondem',
          description:
            'A sala VIP que você está reservando não é no mesmo aeroporto do qual o seu voo está programado para sair.',
        },
        terminalMismatch: {
          title: 'Os terminais não correspondem',
          description:
            'A sala VIP que você está reservando não é no mesmo terminal do qual o seu voo está programado para sair.',
          continueBtn: 'CONTINUAR COM A RESERVA',
        },
        noAmendChanges: {
          title: 'Selecione outros detalhes',
          description:
            'Você não fez nenhuma alteração. Altere sua reserva ou saia da alteração',
          btn: 'ALTERAR RESERVA',
        },
        confirmation: 'Você ainda deseja prosseguir com esta reserva?',
        arrivalTime: 'Selecionar o horário de chegada',
        amendFailed:
          'Ocorreu um erro em sua reserva. Entre em contato com o suporte para obter ajuda.',
        availabilityUnknown: {
          title: 'A disponibilidade é desconhecida',
          description:
            'Desculpe, mas a capacidade para o horário selecionado é desconhecida.',
          solutions: {
            title: 'Você pode',
            points: [
              'alterar o número de convidados',
              'alterar os horários',
              'encontrar outra sala VIP',
            ],
          },
          endText: 'Ou tentar novamente mais tarde',
        },
        btn: {
          edit: 'Editar reserva',
          return: 'Retornar às salas VIP',
        },
      },
    },
    declineAmend: {
      title:
        'Infelizmente, essa reserva não pode ser alterada dentro de {time} horas do horário de chegada.',
    },
    confirmBooking: {
      title: 'Resumo da reserva',
      amendTitle: 'Resumo das alterações da reserva',
      text: 'Confirme se os dados estão corretos antes de fazer o pagamento.',
      btn: 'Ir para pagamento',
      btnNext: 'Próximo',
      loadingModal: {
        title: 'A página está carregando',
        description:
          'Aguarde enquanto a página está carregando. Isso pode levar alguns segundos para concluir. Agradecemos a sua paciência',
      },
    },
    entitlements: {
      title: 'Benefícios da pré-reserva',
      infoModal: {
        title: 'Benefícios da pré-reserva',
        text: 'Os benefícios da pré-reserva estão sendo fornecidos aos titulares de cartão Platinum e Centurion no Reino Unido, cortesia da American Express. Esses benefícios permitem que os titulares de cartão façam a pré-reserva em salas VIP Priority Pass elegíveis no Reino Unido. Ao fazerem a pré-reserva em uma sala VIP elegível, titulares de cartão poderão usar esses benefícios de pré-reserva para fazer a reserva para si mesmos e seus convidados.',
        btnClose: 'FECHAR',
      },
      loungeInfo: {
        entitlementsRemaining: {
          singular: 'direito restante',
          plural: 'direitos restantes',
        },
        unlimitedEntitlements: 'direitos ilimitados restantes',
        entitlementsUsed: 'Direitos utilizados',
      },
      countAndExpiryDate: {
        singular:
          'Você tem {count} benefício de pré-reserva restante, válido até {date}',
        plural:
          'Você tem {count} benefícios de pré-reserva restantes, válidos até {date}',
      },
      unlimitedEntitlements:
        'Você tem direitos ilimitados de pré-reserva, válidos até {date}',
      inputLabel:
        'Selecione o número de benefícios que você gostaria de usar para esta reserva',
      perVisitLimitMessage: 'Você pode usar até {limit} benefícios por visita',
      perVisitRestrictionWarning: 'Restrições por visita se aplicam',
    },
    payment: {
      amendmentPaymentPolicy:
        'Você pagará o valor integral pela alteração da sua reserva existente e será reembolsado com o valor total da reserva original',
      btnGoPayment: 'Ir para pagamento',
      title: 'Dados do pagamento',
    },
    confirmationPayment: {
      title: 'Confirmação da reserva',
      amendTitle: 'Confirmação da alteração da reserva',
      processing: {
        beingProcessed: {
          title: 'O pagamento está sendo processado',
          description: {
            line1: 'Seu pagamento para ',
            line2: 'está sendo processado.',
            line3:
              'Não atualize a página, pode levar alguns minutos para concluir.',
          },
        },
        unsuccessful: {
          title: 'O pagamento falhou',
          description:
            'Não saia desta tela, nem feche o navegador até que a ação termine ',
        },
      },
      outcome: {
        succesful: {
          title: 'Boa notícia! Sua reserva foi confirmada',
          titleAmend: 'Boa notícia! Sua reserva foi alterada',
          refundExplainedLine1:
            'Você será reembolsado com o valor integral da reserva original.',
          refundExplainedLine2:
            'Seu reembolso será processado no cartão bancário usado para pagar a reserva original dentro de 10 dias úteis.',
          refundText:
            ' Você reduziu o número de convidados na sua reserva. Seu reembolso será processado no cartão bancário usado para pagar a reserva original dentro de 10 dias úteis.',
          reference: {
            label: 'Número da reserva',
          },
          emailConfirmationLabel: 'Um e-mail de confirmação foi enviado para',
          entitlementsRedeemed: 'Benefícios resgatados',
          entitlementsRemaining: {
            singular: 'Você tem {count} benefício de pré-reserva restante.',
            plural: 'Você tem {count} benefícios de pré-reserva restantes.',
          },
          unlimitedEntitlements: 'Você tem direitos ilimitados de pré-reserva.',
          noEntitlementsRemaining: 'Você não tem mais direitos de pré-reserva.',
          description:
            'Pedimos desculpas, mas ocorreu um erro durante o processo de pagamento e seu pagamento não foi processado. Solicitamos que você faça uma nova reserva ou repita o pagamento.',
          importantNotes: {
            title: 'Observações importantes',
            notes: {
              one: 'Não se esqueça de levar o número da sua reserva, cartão de embarque e um documento de identificação com foto, além do seu cartão {membershipType} ou outro método de acesso válido para check-in na sala VIP.',
              two: 'Você pode permanecer na sala VIP por até {accessPeriod} horas antes do horário do seu voo.',
              three:
                'Cancele até 48 horas antes da sua reserva para receber um reembolso total. As reservas não podem ser canceladas nem alteradas dentro de 48 horas antes do horário de chegada, incluindo novas reservas feitas nesse período.',
            },
            amendedNote:
              'Você foi cobrado o valor integral pela alteração da sua reserva existente. O valor integral da reserva original será reembolsado no cartão bancário usado para pagar a reserva original dentro de 10 dias úteis.',
          },
          btn: {
            download: 'BAIXAR',
            return: 'Retornar à sala VIP',
          },
        },
        notConfirmed: {
          title: 'Seu pagamento não foi confirmado',
          description:
            'Pedimos desculpas, mas ocorreu um erro durante o processo de pagamento e seu pagamento não foi processado. Solicitamos que você faça uma nova reserva ou repita o pagamento.',
          btn: {
            payment: 'Repetir pagamento',
            return: 'Retornar à sala VIP',
          },
        },
        delay: {
          title: 'Atraso na confirmação da reserva',
          description:
            'Ainda não foi possível confirmar sua reserva; nós lhe enviaremos um e-mail assim que a sua reserva for confirmada',
          btn: 'Retornar às salas VIP',
        },
        delayError: {
          title: 'Nenhuma confirmação recebida',
          description:
            'Ainda não foi possível confirmar sua reserva; nós lhe enviaremos um e-mail assim que a sua reserva for confirmada',
          btn: 'Retornar às salas VIP',
        },
        declined: {
          title: 'Sua reserva não foi aceita',
          description:
            'Pedimos desculpas pelo atraso no processamento. Não foi possível confirmar sua reserva. Considere reservar outro horário.',
          btn: {
            return: 'Retornar às salas VIP',
            select: 'Selecione outro horário',
          },
        },
      },
    },
    cancellation: {
      title: 'Cancelamento da reserva',
      description: 'Você está prestes a cancelar a reserva: tem certeza?',
      reference: 'Número da reserva:',
      btnCancel: 'CANCELAR RESERVA',
      btnClose: 'FECHAR',
      policy: {
        title: 'Política de cancelamento',
        description:
          'Cancele até {time} horas antes da sua reserva para receber o reembolso integral. As reservas não podem ser canceladas dentro de {time} horas do horário de chegada, incluindo novas reservas feitas dentro desse intervalo de tempo.',
      },
      unsuccesful:
        'Infelizmente, essa reserva não pode ser cancelada dentro de {time} horas do horário de chegada',
      btn: 'Confirmar',
      errors: {
        notFound: 'Não foi possível encontrar a reserva',
        alreadyCancelled: 'A reserva já foi cancelada',
        notOwned:
          'Ocorreu um erro em sua reserva. Tente novamente mais tarde ou entre em contato com o suporte',
        failed:
          'Ocorreu um erro em sua reserva. Tente novamente mais tarde ou entre em contato com o suporte',
        notAllowed:
          'Infelizmente, essa reserva não pode ser cancelada dentro de {time} horas do horário de chegada.',
        wrong:
          'Ocorreu um erro em sua reserva. Tente novamente mais tarde ou entre em contato com o suporte',
        expiredBooking: 'A data da reserva já passou e não pode ser alterada',
      },
      confirmation: {
        title: {
          Cancel: 'Sua reserva foi cancelada',
          Failed:
            'O cancelamento da sua reserva falhou, entre em contato com a nossa equipe',
          NotCancel:
            'Não foi possível cancelar a sua reserva, entre em contato com a nossa equipe',
        },
        email: 'Um e-mail de confirmação foi enviado para',
        refund: {
          failed:
            'Tentativa de reembolso falhou. Entre em contato com o seu banco ou com o emissor do cartão para obter ajuda.',
          successful:
            ' Seu pagamento para esta reserva será reembolsado dentro de 10 dias',
        },
        entitlementsRefund:
          'Como você usou seus direitos para esta reserva, eles serão restaurados em sua conta. Aplicam-se Termos e Condições.',
        entitlementsExpiration:
          'Observe que seus benefícios existentes perderão a validade em {date}',
        entitlementsUsed:
          'Como você usou seus direitos para esta reserva, eles serão restaurados em sua conta.',
        reBook:
          'Se você não pretendia cancelar, reserve novamente pelo {accountProvider}. Esperamos vê-lo novamente.',
        moreInformation:
          'Para mais informações, acesse nossa página de {faq:perguntas frequentes}',
        loading: 'Carregando...',
      },
    },
    checkAvailability: {
      arrivalTitle: 'Seleção do horário de chegada',
      amendTitle: 'Alterações na reserva',
      notFoundError: 'Ocorreu um erro. Tente novamente',
      btn: 'VERIFICAR A DISPONIBILIDADE',
    },
    failureBooking: {
      declined: {
        title: 'Sua reserva não foi aceita.',
        description:
          'Infelizmente, durante o processo de pagamento, a capacidade da sala VIP foi alterada e não foi mais possível confirmar sua reserva. Você será reembolsado por qualquer pagamento feito.',
        note: 'Considere reservar outro horário, ou veja se há outra sala VIP disponível.',
        btn: {
          selectAnotherTime: 'SELECIONE OUTRO HORÁRIO',
          returnToLounge: 'Retornar às salas VIP',
        },
      },
    },
    confirmationPDF: {
      title: 'Confirmação da reserva',
      description: {
        line1: 'Boa notícia! Sua reserva para',
        line2: 'em',
        line3: 'foi confirmada.',
      },
      bookingDetails: {
        title: 'Dados da sua reserva',
        reference: 'Número da reserva:',
        date: 'Data:',
        flightNumber: 'Número do voo:',
        timeOfArrival: 'Horário de chegada:',
      },
      guestDetails: {
        title: 'Quem vem?',
        adults: 'Adultos',
        children: 'Crianças',
        infants: 'Bebês',
        seniors: 'Idosos',
      },
      entitlements: {
        redeemed: 'Benefício de pré-reserva resgatado:',
        remaining: 'Benefícios de pré-reserva restantes:',
        validUntil: 'Os benefícios de pré-reserva são válidos até:',
      },
      price: 'Total',
      importantNotes: {
        title: 'Observações importantes',
        checkInNote:
          'Não se esqueça de levar o número da sua reserva, cartão de embarque e um documento de identificação com foto, além do seu cartão {membershipType} ou outro método de acesso válido para check-in na sala VIP.',
        maximumStay:
          'Você pode permanecer na sala VIP por até {accessPeriod} horas antes do horário do seu voo.',
        cancelText:
          'Cancelamentos são permitidos até {time} horas antes da data e horário da sua visita para garantir reembolso. Após esse prazo, não será possível reembolsar o valor pago. ',
        amendText: 'Por favor, clique no link se você deseja ',
      },
      amendLink: 'Editar a reserva',
      cancelLink: 'Clique aqui para cancelar sua reserva',
      forwardText: 'Esperamos você por lá!',
      loadingText: 'Carregando documento…',
      error:
        'Ocorreu um erro ao gerar a confirmação da sua reserva! Por favor, tente novamente.',
    },
    failureAmendmentRefund: {
      title: 'Suas alterações de reserva foram recusadas',
      description:
        'Desculpe, a disponibilidade do lounge mudou enquanto seu pedido estava sendo processado e não foi possível confirmar a edição da reserva. Sua reserva permanece igual. Se ainda quiser editar sua reserva, por favor, tente novamente',
    },
  },
  fastTrack: {
    airport: 'Airport fast track',
    errors: {
      capacity:
        'A capacidade máxima do Airport fast track é um total de {guests} convidados. Mude o número de convidados.',
      noAvailability: {
        title:
          'Lamentamos, o Airport fast track está totalmente reservado para este horário.',
        description:
          'Ainda pode seguir pelas filas de segurança padrão ou selecionar outro horário disponível.',
        cta: 'Encontrar outro horário',
      },
    },
    availabilityButton: 'REVISAR E CONFIRMAR',
    checkLocations: {
      alwaysAvailable: 'Sempre disponível',
      bookButton: 'Reservar {name}',
      greeting: 'Olá, ',
      noTerminal: 'Sem terminal',
      selectedBadge: 'Selecionado',
      subtitle:
        'Por favor selecione a localização de fast track que deseja reservar:',
    },
    consent: {
      consentPage: 'CONSENTIMENTO DE FAST TRACK',
      title: 'Airport fast track Consentimento',
      description:
        'Pule as filas e passe rapidamente pelo controle de segurança do aeroporto para uma viagem mais tranquila em locais selecionados ao redor do mundo.',
      notice: {
        title: 'Aviso importante',
        description: {
          one: 'Observe: Airport Fast Track é um serviço não cancelável, não modificável e não reembolsável. ',
          two: {
            line1:
              'Ao prosseguir, você confirma que leu, entendeu e aceitou os ',
            line2: 'Termos e Condições do Airport Fast Track.',
          },
        },
      },
      btn: 'Concordar e prosseguir',
      fastTrackWarning:
        'Os serviços de Fast Track estão sujeitos à aprovação das autoridades aeroportuárias e de imigração, bem como às regulamentações locais. A elegibilidade pode variar de acordo com o aeroporto, a nacionalidade, o tipo de passaporte e o status do passageiro. Em determinados aeroportos do Vietnã, os serviços de Fast Track podem não estar disponíveis para portadores de passaportes vietnamitas e cambojanos, e o acesso pode ser recusado pelas autoridades locais.',
    },
    entitlement: {
      description:
        'Passe rápido pela segurança do aeroporto para uma viagem mais tranquila e sem estresse.',
      notice: {
        title: 'Aviso importante',
        operatingHours: 'Horário de funcionamento',
        days: {
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        message:
          'Seu acesso ao Fast Track já está incluído na sua associação. Dirija-se à entrada do Fast Track.',
      },
      btn: 'OK',
    },
    downloadVoucher: 'BAIXAR VALE',
    faqLocaleValue: 'pt-BR',
    arrivalTimeDescription:
      'Os horários exibidos seguem o fuso horário local da Airport fast track Lane.',
    importantNotes: {
      one: 'Tenha em mãos o número de referência da reserva, o e-mail de confirmação, o cartão de embarque e o passaporte para garantir uma entrada tranquila na via rápida do aeroporto.',
      two: 'Se o seu e-mail de confirmação contiver um código QR escaneável, certifique-se de tê-lo pronto para escanear ao chegar à faixa de Airport fast track.',
      three: {
        line1:
          'Airport fast track é um serviço não cancelável, não modificável e não reembolsável. Ao continuar, você confirma que entende e aceita estes ',
        line2: 'termos e condições.',
      },
      four: 'O cancelamento da sua reserva deve acontecer no mínimo 2 dias antes da data de sua visita para receber um reembolso. Nenhum reembolso será emitido após esse período.',
      five: {
        line1: 'Procurando onde encontrar a faixa de Airport fast track? ',
        line2: 'Baixe este PDF',
      },
      six: 'Para acessar a entrada de Airport fast track, utilize o código QR no seu e-mail de confirmação. Este PDF de confirmação não pode ser usado como voucher.',
    },
    policies: {
      cancellation:
        'Cancele até dois dias antes da sua reserva Airport fast track para receber o reembolso integral. As reservas Airport fast track não podem ser canceladas dentro de dois dias do horário de chegada, incluindo novas reservas feitas nesse intervalo de tempo. Não é possível alterar uma reserva Airport fast track. Para alterá-la, cancele a reserva original e faça uma nova reserva.',
      terms: {
        line1: 'Consultar ',
        link: 'condições do Airport fast track',
        line2: 'para restrições de idade',
      },
      guests:
        'O tamanho máximo do grupo é {guests}, excluindo bebês. Verifique a disponibilidade para restrições específicas do Airport fast track sobre o número de bebês.',
    },
    timeSlotsDisclaimer:
      'Este é o horário em que chegará à Airport fast track Lane.',
  },
  generic: {
    labels: {
      logo: 'Logotipo da aplicação',
      notification: 'todo_translate_Notification',
      loginPageDescription: 'todo_translate_Login page description',
      airport: 'Airport',
      downloadPdf: 'Baixar PDF',
      pricePerPerson: 'Preço por pessoa',
      pricePerAdult: 'Preço por adulto',
      editBooking: 'Editar reserva',
      selectTimeSlot: 'Selecionar horário',
      error: 'todo_translate_Error page',
      flightDate: 'Data do voo',
      flightNumber: 'Número do voo',
      flightTime: 'Horário do voo',
      loungeName: 'Nome da Sala VIP',
      codeInput: 'Senha de uso único',
      editButton: 'Botão de editar',
      loginEmail: 'Endereço de e-mail de login',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      adults: 'Adultos',
      children: 'Crianças',
      infants: 'Bebês',
      decrementAdults: 'Diminuir a quantidade de Adultos',
      incrementAdults: 'Aumentar a quantidade de Adultos',
      selectedAdults: 'Quantidade de Adultos Selecionados',
      decrementChildren: 'Diminuir a quantidade de Crianças',
      incrementChildren: 'Aumentar a quantidade de Crianças',
      selectedChildren: 'Quantidade de Crianças Selecionadas',
      decrementInfants: 'Diminuir a quantidade de Bebês',
      incrementInfants: 'Aumentar a quantidade de Bebês',
      selectedInfants: 'Quantidade de Bebês Selecionados',
      incrementEntitlements: 'Aumentar a quantidade de Benefícios',
      decrementEntitlements: 'Diminuir a quantidade de Benefícios',
      selectedEntitlements: 'Quantidade de Benefícios Selecionados',
      loading: 'Carregando',
    },
    error: {
      pricingError: {
        title: 'Não foi possível obter o preço',
        message:
          'Não conseguimos obter o preço mais recente para esta sala. Tente novamente mais tarde.',
      },
      unhandledError: {
        title: 'Houve um erro no sistema.',
        message: 'Tente novamente ou explore outras opções.',
      },
      latestAppVersion:
        'Pode ter ocorrido um erro no sistema. Atualize para a versão mais recente do aplicativo.',
      webTitle:
        'Pode ter ocorrido um erro no sistema. Tente novamente ou pesquise outras opções.',
      loungeNoFound:
        'Desculpe, não conseguimos encontrar o quarto que você solicitou.',
      tokenNoFound: 'Desculpe, o token está incorreto ou ausente.',
    },
    branding: {
      MCAECustomBrandName: 'Mastercard Airport Experiences',
    },
  },
};
